import DirectClaims from './DirectClaims';

export default DirectClaims;
